// components/debug/AuthDebug.jsx
import React from 'react';
import { useStudentAuth } from '../../context/StudentAuthContext';

export const AuthDebug = () => {
  const { student, isAuthenticated, authLoading } = useStudentAuth();
  
  const checkCookies = () => {
    const cookies = document.cookie.split(';');
    const studentCookies = cookies.filter(cookie => 
      cookie.includes('student_access_token') || 
      cookie.includes('student_refresh_token')
    );
    
    console.log('🍪 Student Cookies:', studentCookies);
    console.log('👤 Auth State:', { student, isAuthenticated, authLoading });
    
    alert(`Cookies: ${studentCookies.length}\nAuthenticated: ${isAuthenticated}\nUser: ${student?.fullname || 'None'}`);
  };
  
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  
  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      backgroundColor: 'rgba(0,0,0,0.7)',
      color: 'white',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 9999
    }}>
      <div>Auth Debug:</div>
      <div>Student: {student?.fullname || 'None'}</div>
      <div>Authenticated: {isAuthenticated ? 'Yes' : 'No'}</div>
      <div>Loading: {authLoading ? 'Yes' : 'No'}</div>
      <button 
        onClick={checkCookies}
        style={{ marginTop: '5px', padding: '3px 6px', fontSize: '10px' }}
      >
        Check Cookies
      </button>
    </div>
  );
};